import React from "react";
import {Box, FileUploadWithPreview, Paper, Stack, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const FilUploadWithButtonPage = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Custom File upload with update button
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            title={"props - maxFileInfoMessage, width, height, radius, textWidth, isLoading, onChange and onSubmit."}
            value={"<FileUploadWithPreview />"}
          >
            <FileUploadWithPreview />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default FilUploadWithButtonPage;
